import React, { useState, useEffect } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2)
    }
  },
  alert: {
    whiteSpace: 'pre-line'
  }
}));
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

//const Toasty = (props) => {
const Toasty = (props) => {
  const classes = useStyles();
  const action = props.action;
  const [open, setOpen] = React.useState(false);
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };
  useEffect(() => {
    if (action.message !== '') setOpen(true);
  }, [action]);

  return (
    <Snackbar open={open} autoHideDuration={!!props.time ? props.time : 6000} onClose={handleClose}>
      <Alert onClose={handleClose} severity={action.type} className={classes.alert}>
        {action.message}
      </Alert>
    </Snackbar>
  );
};
const useToasty = () => {
  /* action : success, error, info, warning
   */

  const [action, setAction] = useState({
    type: 'success',
    message: '',
    open: false
  });
  const setValue = (message, type = 'success') => {
    //setAction({ open: true, message: message, type: type });
    setAction({ open: true, message: message, type: type });
  };
  return [action, setValue];
};

export { Toasty, useToasty };
